import './App.css';
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Generator } from './components/Generator';
import { signOut } from "firebase/auth";
import { auth } from "./firebase-config";
import SignIn from "./components/SignIn";

function App() {
  const [isAuth, setIsAuth] = useState(localStorage.getItem("isAuth"));

  const signUserOut = () => {
    signOut(auth).then(() => {
      localStorage.clear();
      setIsAuth(false);
      window.location.pathname = "/";
    });
  }; 
  return (
    <Router>
    <header className='header'>
      <nav className='navBar'>
        {/* {!isAuth ? ( */}
          <Link to="/" className='navBtn'> Home </Link>
        {/* ) : ( */}
          <>
          <div className='nav-links'>
            <Link to="/Generator" className='navBtn'>Generate words</Link>
          </div>
            {/* <button className='logOutBtn' onClick={signUserOut}>Sign out</button> */}
          </>
        {/* )} */}
      </nav>
      </header>
      <Routes>
        <Route path="/" element={<Generator/>} />
        {/* <Route path="/" element={<SignIn setIsAuth={setIsAuth} />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
